import { Hero } from './sections/Hero';
import { ValueProposition } from './sections/ValueProposition';
import { FeatureList } from './sections/FeatureList';
import { ComparisonTable } from './sections/ComparisonTable';
import { AttckCredibility } from './sections/AttckCredibility';
import { Footer } from './sections/Footer';

export default function App() {
  return (
    <>
      <main className="min-h-screen bg-[color:var(--color-canvas)] text-[color:var(--color-foreground)]">
        <Hero />
        <ValueProposition />
        <FeatureList />
        <ComparisonTable />
        <AttckCredibility />
      </main>
      <Footer />
    </>
  );
}
